import { Mail, HeartHandshake } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function BookYourFreeBalHarbourInspection() {
  return <section data-section-id="260504" id="application-cta" className="bg-primary-100 text-foreground py-16 md:py-24 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
          <div className="h-1 w-12 bg-secondary-500 mx-auto mb-6 rounded-full" />

          <p className="text-secondary-700 font-semibold tracking-[0.18em] uppercase text-xs mb-4 font-default">
            Careers at RiverBend
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-600 tracking-tight leading-tight">
            Interested in working with RiverBend?
          </h2>

          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl leading-relaxed mt-6">
            We are always interested in hearing from people who value practical
            work, clear communication, respectful client support, and meaningful
            opportunities to help organizations move important work forward.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full sm:w-auto mt-9">
            <Button type="button" size="lg" onClick={() => {
            window.location.href = "/contact/";
          }} className="w-full sm:w-auto rounded-md text-base h-14 px-8 bg-primary-600 hover:bg-primary-700 text-primary-foreground shadow-sm inline-flex items-center justify-center">
              <Mail className="mr-2 size-5" />
              Contact Us About Opportunities
            </Button>

            <Button type="button" variant="outline" size="lg" onClick={() => {
            window.location.href = "/our-commitment-to-employees/";
          }} className="w-full sm:w-auto rounded-md text-base h-14 px-8 border-primary-200 text-primary-600 hover:bg-primary-50 font-semibold inline-flex items-center justify-center">
              <HeartHandshake className="mr-2 size-5" />
              Read Our Commitment to Employees
            </Button>
          </div>

          <p className="text-sm text-muted-foreground font-default mt-6">
            Applications and employment inquiries can also be sent to{" "}
            <a href="mailto:employment@riverbendcorp.ca" className="text-secondary-700 font-semibold hover:text-secondary-800 underline underline-offset-4">
              employment@riverbendcorp.ca
            </a>
            .
          </p>
        </div>
      </div>
    </section>;
}